/**
 * Backend errors carry `detail` as a string, a validation array, or a structured
 * `{code, message, ...extras}` object (e.g. 409 ABHA_ALREADY_LINKED with patient_id).
 * Returns the structured object or null — single reader shared by visitApi + appointmentApi.
 */
export function structuredDetail(error) {
  const detail = error?.response?.data?.detail;
  return detail && typeof detail === 'object' && !Array.isArray(detail) ? detail : null;
}

/**
 * FastAPI request-validation 422s carry `detail` as an ARRAY of pydantic errors. Returns a readable
 * "field: message; ..." string for one, or null for any other shape — shared by visitApi + appointmentApi.
 */
export function validationMessage(detail) {
  if (!Array.isArray(detail) || !detail.length) return null;
  return detail.map((d) => `${(d.loc || []).slice(1).join('.')}: ${d.msg}`).join('; ');
}
